import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-19210518"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main-layout-body"
};
import { onMounted, ref } from "vue";
import { ElLoading } from "element-plus";
import { useStore } from "vuex";
import PageHeader from "./PageHeader.vue";
import { getUserInfo } from "@/utils/authority";
import { useRouter } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const router = useRouter();
    const store = useStore();
    const initLoading = ref(false);
    onMounted(() => {
      console.log("mian-layout");
      const userInfo = getUserInfo();

      if (!userInfo.token) {
        window.location.href = "/login";
      }
    });

    const openFullScreen1 = () => {
      const loading = ElLoading.service({
        lock: true,
        text: "Loading"
      });
      initLoading.value = true;
      store.dispatch("app/initData").then(res => {
        loading.close();
        initLoading.value = false;
      });
    };

    openFullScreen1();
    return (_ctx, _cache) => {
      const _component_el_header = _resolveComponent("el-header");

      const _component_router_view = _resolveComponent("router-view");

      const _component_el_container = _resolveComponent("el-container");

      return !initLoading.value ? (_openBlock(), _createBlock(_component_el_container, {
        key: 0,
        class: "main-layout-container"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_header, {
          style: {
            "height": "56px"
          }
        }), _createVNode(_component_el_header, {
          class: "main-layout-header"
        }, {
          default: _withCtx(() => [_createVNode(PageHeader)]),
          _: 1
        }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_router_view)])]),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }

});